import { AiGeneratedFlagVariantDto, AiGeneratedMetricDto } from './types';

export const DEFAULT_PREMAPPED_AI_VARIANTS: AiGeneratedFlagVariantDto[] = [
  {
    name: 'Variant A',
    value: 'Variant A',
    distribution: 50,
  },
  {
    name: 'Variant B',
    value: 'Variant B',
    distribution: 50,
  },
];

export const DEFAULT_RAW_TRUE_VARIANT = {
  name: 'Enabled',
  value: true,
};

export const DEFAULT_RAW_FALSE_VARIANT = {
  name: 'Disabled',
  value: false,
};

export const DEFAULT_AI_METRICS: AiGeneratedMetricDto[] = [];
